<div
  class="block"
  [ngClass]="{ topele: themeService.flag, 'topele-light': !themeService.flag }"
  id="top"
>
  <div id="particles-js" class="nbg">
    <div class="particle-content">
      <div class="mt-5">
        <span class="inline-block mb-3 p-3"
          >
          <img
            [src]="dataService.info.image_urls.display"
            alt="image"
            class="
              col-8 col-md-6
              p-0
              col-md-3
              img-fluid
              avatar
              depth
            "
          />
        </span>
        <h3 class="inline-block mt-3 mb-1 font-oxygen title">
          Hi! I am <span class="name">{{ dataService.info.name }}</span
          >.<span class="h3"
            ><i class="fa fa-volume-up" (click)="playf()"></i
          ></span>
        </h3>
        <h4 class="inline-block mb-1 mt-0 font-oxygen title">
          People call me
          <span class="name">{{ dataService.info.nick_name }}</span
          >.<span class="h3"
            ><i class="fa fa-volume-up" (click)="plays()"></i
          ></span>
        </h4>
        <h5 class="inline-block mb-1 mt-0 font-oxygen title">
          <ngx-typed-js
            (completed)="delay()"
            [loop]="true"
            [backSpeed]="80"
            [smartBackspace]="true"
            [showCursor]="true"
            [cursorChar]="'_'"
            [cursorColor]="'#7B8788'"
            [strings]="['a Developer.', 'an Engineer.', 'a Musician.']"
            [typeSpeed]="50"
          >
            I'm <span class="typing font-oxygen mysubtitle my-3"></span>
          </ngx-typed-js>
        </h5>
        <h5 class="inline-block mb-1 mt-0 font-oxygen title">
          I <i class="fa fa-heart nameh"></i> to Code and play Musical
          Instruments!
        </h5>
        <h5 class="inline-block mb-3 mt-0 font-oxygen title">
          Here's my
          <a
            tabindex="-1"
            target="_blank"
            href="https://mysticalcoder.com/"
          >
            <span class="name l"><u>Blog</u></span></a
          >.
        </h5>
      </div>
      <div class="inline-block py-1">
        <a
          *ngFor="let homeLink of home_links; let i = index"
          tabindex="-1"
          [href]="homeLink.href"
          target="_blank"
        >
          <button tabindex="-1" class="btn mx-1 btn-outline-light" [ngClass]="{'outline-red': homeLink.iconClass.startsWith('fa-youtube')}">
            <i class="fa mx-2" [ngClass]="homeLink.iconClass"></i>
          </button>
        </a>
      </div>
      <div class="scroll-oval">
        <i class="fa fa-chevron-down"></i>
      </div>
    </div>
  </div>
</div>
<app-home-about [navigate]="navigate"></app-home-about>
<div class="banner banner1">
  <p class="quote font-pacifico">
    "{{ dataService.quotes[2].text }}" ~ {{ dataService.quotes[2].by }}
  </p>
</div>
<app-home-skills [navigate]="navigate"></app-home-skills>
<div class="banner banner2">
  <p class="quote font-pacifico">
    "{{ dataService.quotes[0].text }}" ~ {{ dataService.quotes[0].by }}
  </p>
</div>
<app-home-experience [navigate]="navigate"></app-home-experience>
<div class="banner banner3">
  <p class="quote font-pacifico">
    "{{ dataService.quotes[1].text }}" ~ {{ dataService.quotes[1].by }}
  </p>
</div>
<app-home-projects [navigate]="navigate"></app-home-projects>
<div class="banner banner4">
  <p class="quote font-pacifico">
    "{{ dataService.quotes[3].text }}" ~ {{ dataService.quotes[3].by }}
  </p>
</div>
<app-home-achievements [navigate]="navigate"></app-home-achievements>
<div class="banner banner5">
  <p class="quote font-pacifico">
    "{{ dataService.quotes[5].text }}" ~ {{ dataService.quotes[5].by }}
  </p>
</div>
<app-home-contact [navigate]="navigate"></app-home-contact>
<div class="banner banner6">
  <p class="quote font-pacifico">
    "{{ dataService.quotes[4].text }}" ~ {{ dataService.quotes[4].by }}
  </p>
</div>
